const Routes = {
  HOME: "/",
  ABOUT: "/about",
  USERS: "/users",
  TERMCOND: "/termsconditions",
  SEARCH: "/search",
  MAP: "/map",
  CATEGORY: "/category",
  PETS: "/pets",
  ACCESORIES: "/accesories",
  SERVICE: "/service",
  FOOD: "/food",
};

export default Routes;
